module.exports = __webpack_public_path__ + "static/media/virtual_background.225a1974.png";